import React from 'react';
import PropTypes from 'prop-types';
import FluidImage from 'components/fluid-image';
import Text from 'components/text';

const Teaser = ({ image, initialImageWidth = 800, title, body }) => {
  return (
    <div className="teaser">
      <div className="teaser__image">
        {image && (
          <FluidImage
            {...image}
            initialSize={image.initialSize || initialImageWidth}
          />
        )}
      </div>
      {title && (
        <Text.h4 theme={Text.themes.uppercase} className="teaser__title">
          {title}
        </Text.h4>
      )}
      {body && <Text.p className="teaser__body">{body}</Text.p>}
    </div>
  );
};

Teaser.propTypesMeta = {
  initialImageWidth: 'exclude'
};

Teaser.propTypes = {
  image: PropTypes.exact(FluidImage.propTypes),
  initialImageWidth: PropTypes.number,
  title: PropTypes.string,
  body: PropTypes.string
};

export default Teaser;
